import React, { useState } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import {ENTITY_LABELS} from "../../utils/labelMapping"
import classes from "./FormModal.module.css";

function BrandCompetitorFormModal({
  show,
  handleClose,
  handleAddBrandCompetitor,
  customerBrands,
}) {
  const competitorBrands = useSelector((state) => state.competitorBrands);
  const [brandName, setbrandName] = useState("");
  const [brandDescription, setbrandDescription] = useState("");
  const [selectedBrand, setSelectedBrand] = useState("");

  const handleAddBrandCompetitorInfo = () => {
    const brandId = customerBrands.filter(
      (brand) => brand?.brand?.name === selectedBrand
    )[0]?.id;
    const payload = {
      brand_name: brandName,
      brand_description: brandDescription,
      brand_id: brandId,
    };

    handleAddBrandCompetitor(payload);
  };

  return (
    <Modal
      style={{ border: "none", borderRadius: "0px" }}
      show={show}
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title style={{ color: "grey", fontSize: "20px" }}>
          {`Add Competitor ${ENTITY_LABELS.brand}`}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Control
          style={{ padding: "12px 12px", width: "70%", margin: "auto" }}
          as="textarea"
          rows={1}
          cols={2}
          name="firstName"
          placeholder={ENTITY_LABELS.brand}
          // className="big"
          value={brandName}
          onChange={(e) => setbrandName(e.target.value)}
        />
        <p> </p>
        <Form.Control
          style={{ padding: "12px 12px", width: "70%", margin: "auto" }}
          as="textarea"
          rows={2}
          cols={2}
          name="firstName"
          placeholder="Details for disambigution"
          // className="big"
          value={brandDescription}
          onChange={(e) => setbrandDescription(e.target.value)}
        />
        <p> </p>

        <Form.Group>
          <Form.Control
            as="select"
            value={selectedBrand}
            onChange={(e) => {
              setSelectedBrand(e.target.value);
            }}
            style={{ height: "50px", width: "330px", margin: "auto" }}
          >
            <option value="">{`select ${ENTITY_LABELS.brand}`} </option>
            {customerBrands &&
              customerBrands.length !== 0 &&
              customerBrands.map((brand) => (
                <option value={brand?.brand?.name}>{brand?.brand?.name}</option>
              ))}
          </Form.Control>
        </Form.Group>

        <br />
      </Modal.Body>
      <Modal.Footer
        style={{ justifyContent: "center" }}
        className={classes.actions}
      >
        <Button
          disabled={competitorBrands?.loading}
          style={{ backgroundColor: "green", width: "30%" }}
          variant="success"
          onClick={() => handleAddBrandCompetitorInfo()}
        >
          {competitorBrands?.loading ? (
            <div style={{ fontSize: "14px" }}>
              <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
              />
              Please Wait...
            </div>
          ) : (
            <div>Add</div>
          )}
        </Button>
        <Button
          style={{ backgroundColor: "#d32f2f", width: "30%" }}
          variant="danger"
          onClick={handleClose}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default BrandCompetitorFormModal;
